import { isRestricted, addFullMapping } from '../util/helpers';
import { get, set } from 'lodash';
import AjaxUtils from '../util/ajax_utils';

export const ConfigForm = {
    props: {
        schema: {
            type: [String, Object],
        },
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        errors: {
            type: Array,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        collapsed: {
            type: Boolean,
            default: false,
        },
        collapsible: {
            type: Boolean,
            default: true,
        },
        header: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        return {
            title: '',
            type: '',
            fields: [],
            formValue: '',
            localValue: {},
        };
    },
    watch: {
        value(value) {
            if (this.localValue !== value) {
                this.localValue = JSON.parse(JSON.stringify(value || {}));
                if (this.fields.length) {
                    this.applySchemaDefaults(this.fields);
                    this.emitValue();
                }
            }
        },
        schema(newSchema) {
            this.loadSchema();
        },
    },
    mounted: function () {
        this.localValue = this.value;
        this.loadSchema();
    },
    methods: {
        loadSchema: function () {
            var cmp = this;
            if (cmp.schema && typeof cmp.schema === 'string') {
                AjaxUtils.ajax_get({
                    url: cmp.schema,
                    success: function (data) {
                        if (data) {
                            cmp.handleSchema(data);
                        }
                    },
                });
            }
            if (cmp.schema && typeof cmp.schema === 'object' && cmp.schema.fields && cmp.schema.type) {
                cmp.handleSchema(cmp.schema);
            }
        },
        hasPermission(el) {
            return !isRestricted(el, this.$permissions);
        },
        filterSchemaByPermissions(fields) {
            // Recursively filter schema items based on permissions.
            const result = [];
            for (const element of fields) {
                if (!this.hasPermission(element)) continue;

                const schema = { ...element };
                if (schema.tabs) schema.tabs = this.filterSchemaByPermissions(schema.tabs);
                if (schema.fields) schema.fields = this.filterSchemaByPermissions(schema.fields);
                result.push(schema);
            }
            return result;
        },
        handleSchema(data) {
            const cmp = this;
            const schemaFields = this.filterSchemaByPermissions(data.fields);
            this.title = data.title || '';
            this.type = data.type || '';
            const mapping = data.mapping || '';
            addFullMapping(schemaFields, mapping, cmp.$permissions);
            this.fields = JSON.parse(JSON.stringify(schemaFields));
            this.applySchemaDefaults(this.fields);
            this.emitValue();
        },
        applySchemaDefaults(fields) {
            for (const element of fields) {
                if (element.tabs) {
                    this.applySchemaDefaults(element.tabs);
                    continue;
                }
                if (element.fields) {
                    this.applySchemaDefaults(element.fields);
                    continue;
                }

                if (!element.full_mapping) continue;

                const current = get(this.localValue, element.full_mapping);
                if (typeof current === 'undefined' && typeof element.default !== 'undefined') {
                    set(this.localValue, element.full_mapping, element.default);
                }
            }
        },
        handleInput({ mapping, value }) {
            set(this.localValue, mapping, value);
            this.emitValue();
        },
        emitValue() {
            this.localValue = { ...this.localValue };
            this.formValue = JSON.stringify(this.localValue);
            this.$emit('input', this.localValue);
        },
    },
    template: `
        <div class="config-form">
            <apck-section
                v-if="type == 'section'"
                :title="title"
                :fields="fields"
                :search="true"
                :errors="errors"
                :collapsed="collapsed"
                :collapsible="collapsible"
                @field-input="handleInput"
                :local-value="localValue"
                :header="header"
            >
                <slot></slot>
                <template v-slot:bottom>
                    <slot name="bottom">
                    </slot>
                </template>
            </apck-section>
            <input v-if="name" type="hidden" :name="name" :value="formValue"  />
        </div>
    `,
};